import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-segment',
  templateUrl: './segment.component.html',
  styleUrls: ['./segment.component.scss'],
})
export class SegmentComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit() {}

  redirecTo(event: any) {
    if (event.detail.value === '/market-place/search/1') {
      this.router.navigate([event.detail.value], { queryParams: { setPrice: 1 } });
    } else {
      this.router.navigate([event.detail.value]);
    }
  }
}
